var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWidthIcon = function SvgWidthIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M2.813 2.75h-.938a.125.125 0 0 0-.125.125v10.25c0 .069.056.125.125.125h.938a.125.125 0 0 0 .124-.125V2.875a.125.125 0 0 0-.124-.125m11.312 0h-.937a.125.125 0 0 0-.126.125v10.25c0 .069.057.125.126.125h.937a.125.125 0 0 0 .125-.125V2.875a.125.125 0 0 0-.125-.125M12.27 7.88l-1.993-1.574a.113.113 0 0 0-.183.09v1.042H5.906v-.982a.113.113 0 0 0-.183-.089L3.73 7.942a.112.112 0 0 0 0 .177l1.992 1.575a.113.113 0 0 0 .183-.09V8.564h4.187v.98c0 .095.11.148.183.09l1.992-1.575a.113.113 0 0 0 .003-.178"
  })));
};
export default SvgWidthIcon;